import { Pressable, View } from 'react-native';
import { style } from './Drawer.style';
import { useStore } from 'src/contexts/StoreContext';
import { DRAWER_POSITIONS, DRAWER_VIEWS } from 'src/store/drawer/drawer.constants';
import { observer } from 'mobx-react-lite';
import Animated, {
  FadeIn,
  FadeOut,
  SlideInLeft,
  SlideInRight,
  SlideOutLeft,
  SlideOutRight,
} from 'react-native-reanimated';
import { ANIMATION_DURATION } from './Drawer.constants';
import { DrawerPhotoDrawer } from '../drawer-photo-drawer/DrawerPhotoDrawer';
import { DrawerLogin } from '../drawer-login/DrawerLogin';

const DrawerMap: Record<DRAWER_VIEWS, () => JSX.Element | undefined> = {
  [DRAWER_VIEWS.Login]: DrawerLogin,
  [DRAWER_VIEWS.PhotoDrawer]: DrawerPhotoDrawer,
};

export const Drawer = observer(() => {
  const {
    drawer: { drawerPosition, drawerView, drawerVisible, withBackdrop, closeDrawer },
  } = useStore();

  let animationIn, animationOut, position;
  switch (drawerPosition) {
    case DRAWER_POSITIONS.Left:
      animationIn = SlideInLeft.duration(ANIMATION_DURATION);
      animationOut = SlideOutLeft.duration(ANIMATION_DURATION);
      position = { left: 0 };
      break;
    case DRAWER_POSITIONS.Right:
      animationIn = SlideInRight.duration(ANIMATION_DURATION);
      animationOut = SlideOutRight.duration(ANIMATION_DURATION);
      position = { right: 0 };
      break;
  }

  const Component = DrawerMap[drawerView];
  return (
    drawerVisible && (
      <>
        {withBackdrop && (
          <Animated.View
            entering={FadeIn.duration(ANIMATION_DURATION)}
            exiting={FadeOut.duration(ANIMATION_DURATION)}
            style={style.background}
          >
            <Pressable style={style.layer} onPress={closeDrawer} />
          </Animated.View>
        )}
        <Animated.View entering={animationIn} exiting={animationOut} style={[style.content, position]}>
          <Component />
        </Animated.View>
      </>
    )
  );
});
